// custom titles for cta forms
const titleMapping = {
    "Warranty Claims": "Claim Warranty Today",
    "Appeal Parking Tickets": "Beat My Ticket For Me",
    "Burner Phones": "Get A Burner Phone Now",
    "Chargebacks and Refunds": "Get Me A Refund",
    "College Fee Waivers": "Waive My Fees For Me",
    "Connect With an Inmate": "Connect With an Inmate Today",
    "Copyright Protection": "File a DMCA Takedown Now",
    "Get Free Trials & Don't Get Charged": "Get a Free Trial Today",
    "Cancel A Subscription": "Cancel My Subscription Now",
    "Help With Bills": "Lower My Bills For Me",
    "Robocall Compensation": "Fight Robocallers for Cash",
    "Fight Email Spam": "Block all spam and sue for cash",
    "Fight Text Spam": "Block all spam and sue for cash",
    "Find Unclaimed Money": "Find Unclaimed Money For Me",
    "Sue Anyone in Small Claims Court": "Help Me Sue Now For Cash",
    "Freedom of Information Act": "Access My Public Records Now",
    "Government Tests": "Ace the Exam Now",
    "Stalking and Harassment": "Get Protected Now",
    "Reducing Property Taxes": "Lower My Taxes For Me",
    "Insurance Claims": "Claim My Insurance Now",
    "Online Fax": "Fax My Document Quickly",
    "Standardized Legal Documents": "Create My Custom Document Now",
    "Compensation for Victims of Crime": "Get My Compensation Now",
    "Notarize Documents": "Notarize My Document Now",
    "Mailing as a Service": "Send Mail With One-Click",
    "Child Travel Consent Form": "Create My Own Form Now",
    "Clinical Trials": "Sign Up For A Clinical Trial Today",
    "Free Raffle Tickets": "Get My Free Raffle Tickets Now",
    "HR Complaints": "File Anonymous HR Complaints Without Fear of Repercussions",
    "Late Delivery Refunds": "Get Reimbursement for Late, Damaged, or Missing Deliveries",
    "Neighbor Complaints": "Resolve Any Issues With Annoying Neighbors",
    "Create a Power of Attorney": "Create a Durable Power of Attorney in Minutes",
    "Item Return Request": "Return Defective, Broken, or Unwanted Items and Get Your Money Back",
    "Gift Card Cash Back": "Redeem Cash on Unused Gift Cards Fast",
    "Create Passport Photos": "Leverage the Power of AI to Create Perfect Passport Photos Fast",
    "Contact Embassies and Consulates": "Contact Any Embassy or Consulate and Have Your Issue Resolved ASAP",
    "Sex Offender Search": "Get Regular Reports on Sex Offenders in Your Area & Keep Loved Ones Safe",
    "Divorce Settlement Agreement": "Draft a Divorce Settlement Agreement Without Spending a Small Fortune on Lawyers",
    "Tourist Visa Guide": "Get All the Info You Need Regarding Tourist Visas for Any Country in the World",
    "File a Complaint": "File Formal Complaints in Seconds and Fight Back Against Any Company That Wronged You",
    "Discover and Apply for Scholarships": "Find All Eligible Scholarships and Grants and Apply With a Single Click",
    "Financial Aid Appeal Letters": "Secure More Financial Aid and Continue Your Education",
    "Appeal Banned Account": "Get Your Accounts Unbanned and Unsuspended Fast",
    "Fight Workplace Discrimination": "Get Your Voice Heard and Never Get Discriminated in the Workplace Again",
    "Notice of Intent To Homeschool": "Bypass the Bureaucracy and Draft a Notice of Intent To Homeschool in Minutes",
    "Defamation Demand Letters": "Draft Professional Defamation Demand Letters In Minutes",
    "Contact Government Representatives": "Contact Any Government Representative and Have Your Voice Heard",
    "Breach of Contract": "Create a Demand Letter and Put Legal Pressure on Clients Who Won't Pay",
    "Small Business Loan Request Letter": "Register Your Trademark Hassle-Free and Protect Your Brands and Your Business",
    "Trademark Registration": "Register Your Trademark Hassle-Free and Protect Your Brand and Your Business",
    "Dispute Seatbelt Tickets": "Appeal Seatbelt Tickets and Save Hundreds of Dollars a Year",
    "Advance Health Care Directive": "Draft a Professional Advance Health Care Directive and Secure Your End-of-Life Care",
    "Find Lost Items": "Track Down Lost Items Fast With DoNotPay",
    "File Converter": "Convert Any File Online—Fast, Easy, Secure",
    "Revocable Living Trust": "Plan for the Future With DoNotPay—Create a Revocable Living Trust In Minutes",
    "Airline Flight Compensation Hacks": "Get Compensation For Cancelled and Delayed Flights and Poor Wi-Fi",
    "Credit Cards": "Use Virtual Credit Cards for Sign-Ups and Never See Unwanted Charges on Your Credit Card Again",
    "Jump the Phone Queue for Any Company": "Jump the Phone Queue and Never Wait on Hold Again!",
    "Schedule Appointments With the DMV": "Faster, Easier, Stress-Free Way To Schedule a DMV Appointment",
    "Remove Background Image": "Remove Backgrounds from Images with One Click",
    "City Repairs": "Request City Services and Report Issues Fast",
    "Find Discounts": "Quickly Discover the Best Deals Possible",
    "Clean Credit Report": "Remove Negative Remarks and Boost Your Score Now",
    "Car Registration Renewal": "Get Your Registration Renewed in a Few Clicks",
    "Planning Permissions": "Get Guidance and Start Building Today",
    "Divorce Certificates": "Request a Copy of Your Divorce Certificate Now",
    "Casino Taxes": "Prepare for Taxes & Track Your Wins/Losses Today",
    "Inflation Pay Request": "Increase Your Salary and Get What You Deserve",
    "Birth Certificates": "Quickly Request Copies of Birth Certificates",
    "Change Mailing Address": "File Your Mailing Address Change Today",
    "Cancel Timeshares": "Have Regrets About a Timeshare Purchase? Act Now.",
    "Section 8": "Apply for Clean, Safe, and Affordable Housing Now",
    "Lower Your Payday Loans": "Negotiate Your Loans and Get Better Terms",
    "File SEC Complaints": "File an Official Complaint to the SEC with One Click",
    "Hotel Upgrades": "Make Your Next Hotel Stay Extra Special",
    "Take Down Personal Information": "Regain Full Control Over Your Private Information",
    "Request Jury Duty Leave": "Own Your Legal Rights and Request Paid Jury Duty Leave",
    "Request Sick Leave": "Own Your Rights and Request Sick Leave Now",
    "Find Lost Airport Items": "Recover Your Lost Items Today",
    "Lounge Access": "Access and Experience Premium Airport Lounges Today",
    "Animal Control": "Report and Get Justice for Animal Injuries Now",
    "Warrant Lookup": "Check for Warrants in Your Name in a Few Clicks",
    "Military Protection": "Request Veteran Benefits and Assistance Today",
    "Report Tax Fraud": "Report Tax Fraud and Claim Your Reward in a Few Clicks",
    "Utility Outages": "Claim Compensation for Outages Now",
    "Car Lease Negotiation": "Get the Best Terms for Your Lease Now",
    "Close Bank Accounts": "Submit Your Formal Bank Closure Request Now",
    "Gambling Protection": "Quit Gambling and Get Protected Today",
    "Free Fast Food": "Score Free Fast Food With Only Your Receipt!",
    "Price Gouging": "Cash Out on Price Gouging Merchants Now",
    "Recalls": "Claim a Refund, Repair, or Replacement for Recalls Fast",
    "Senior Living Assistance": "Find the Perfect Community for the Best Price Today",
    "Do Not Mail": "Declutter Your Mailbox and Block Physical Spam Mail",
    "Pet Licenses": "Renew, Replace, or Register for Pet Licenses in a Few Clicks",
    "Pay Bills Online": "Pay Your Bills Online and Never Miss a Payment Again",
    "Death Certificates": "Quickly Request Copies of Death Certificates",
    "Marriage Certificates": "Get Government Issued Marriage Certificates Now",
    "Identity Theft": "Take Control of Your Identity and Get Protected Now",
    "Release of Liability": "Complete a Release of Liability Contract Quickly",
    "83B Election": "Save Time and Get Your 83B Election Filed Automatically",
    "Increase Credit Limit": "Request a Higher Credit Limit in a Few Clicks",
    "Hunting Licenses": "Apply for Hunting Licenses in Any State Today!",
    "Concert Ticket Scams": "Resolve Concert Ticket Scam Issues in Just a Few Clicks",
    "Report Animal Abuse": "Stop Animal Cruelty and Make a Report Now",
    "Recover Account Passwords": "Save Time and Regain Access to Your Accounts",
    "File Police Report": "Fight Crime and Submit a Police Report Today",
    "Fishing Licenses": "Apply for Fishing Licenses in Any State Today!",
    "Naturalization and Citizenship Certificate": "Request USCIS Naturalization or Citizenship Certificates Now",
    "Find the Best Schools": "Find the Best Education for Your Child Today!",
    "Lost and Found Pets": "Report Lost and Found Pets in Any City Today!",
    "Fight and Waive Fees": "Appeal Any Fee and Get Your Money Back Now",
    "Negotiate Hotel Bill": "Fix Errors on Your Bill and Negotiate Hidden Fees",
    "Delete Accounts": "Protect Your Privacy and Delete Old Accounts",
    "Analyze TOS": "Scan Websites for Violations and Demand Compensation Now",
    "Donate Plasma For Cash": "Help Save Lives and Earn Money While You’re At It",
    "Break My Lease": "Break Your Lease and Minimize Expenses Today",
    "Recover Hacked Accounts": "Regain Access to Your Account Now",
    "83(b) Election": "Save Time and Get Your 83B Election Filed Automatically",
    "Claim My Rebates": "Claim Your Dues and Get Cash Today!",
    "Landlord Protection": "Take Back Your Rights as a Tenant Now",
    "Egg Donor Rights": "Make an Impact By Becoming an Egg Donor and Get Paid",
    "Emotional Support Animal": "Get Assistance On All ESA-Related Concerns Now!",
    "File for Bankruptcy": "Get Financial Relief and File for Bankruptcy Now",
    "Redeem Damaged Money": "Replace Damaged Money in Just a Few Clicks!",
    "Burner Card For Reservations": "Make Reservations Without Using Your Own Credit Card Today!",
    "Voter Registration": "Get All of Your Voter Registration Needs Handled in Seconds!",
    "Quote My Repair": "Snag the Best Price for Any Repair Today!",
    "Help With Rent": "Get Connected to a Local Housing Authority and Receive Rental Assistance",
    "Convert Points and Miles": "Track, Convert, and Redeem Your Points for Rewards Now!",
    "Free Dental Care": "Quickly Find Free Dental Care Near You",
    "Request Medical Records": "Obtain Medical Records in Just a Few Clicks!",
    "Annul My Marriage": "Get Assistance With Annulments in Just a Few Clicks!",
    "Stop Debt Collectors": "Put a Stop to Debt Collectors Once and For All",
    "Make Money Online": "Get Your Options For Extra Income In Just A Few Clicks!",
    "Fight Bank Fees": "Appeal and Refund Unnecessary Bank Fees Now!",
    "Price Match": "Price Match Anything and Aet Refunded Now",
    "Cancel Anything": "Cancel Anything for Me and Get My Money Back",
    "Parental Leave Requests & Benefits": "Request Parental Leave & Benefits for Me",
    "Request Testing Accommodations": "Get Testing Accommodations for Me",
    "Delaware Code 220 Request": "Access Corporate Books & Records",
    "Child Support Payments": "Get Overdue Payments Quickly",
    "Print Quality Photos From Home": "Print My Photos & Deliver Them Fast",
    "Dispute Traffic Tickets": "Beat My Ticket For Me",
    "Car Repossession Issues": "Stop a Car Repossession Now",
    "Request Jury Duty Exemption": "Request an Excusal From Jury Duty ",
    "Negotiate My Salary": "Help Me Get a Raise",
    "Remove Negative Reviews & Photos": "Remove Reviews Before it’s Too Late",
    "Remove My Lien": "Get My Lien Released Now",
    "Report Moving Issues": "Get Compensated for Moving Issues Now",
    "Hotel Complaints and Refunds": "Get My Hotel Bill Refunded Now",
    "File a Restraining Order": "File a Restraining Order for Me",
    "Get Cash Back": "Get Cash Back For Me",
    "Appeal Speeding Tickets": "Beat My Ticket For Me",
    "Photo Ninja": "Make My Photos Reverse-Search-Proof",
    "Fuel Rewards": "Get Free Gas Now",
    "Find Prescription Discounts": "Get Discounts on Prescription Drugs Now",
    "Appeal Toll Booth Tickets": "Beat My Ticket For Me",
    "Rental Car Upgrades": "Get Me a Free Rental Car Upgrade",
    "HOA Fines and Complaints": " Fight My HOA and Win",
    "Fight Medical Fraud": "Correct My Medical Bills Now",
    "Frozen Crypto Funds": "Recover My Crypto Account Now",
    "Find My Lost Pet": "Contact Me When You Find My Pet",
    "Fight Corporations": "Fight Corporations and Seek Justice",
}
let getCtaTitle = (category) => {
    category = category.replace("&amp;", "&")
    if (category) {
        return titleMapping[category]
    }
}
module.exports = { getCtaTitle };